import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

/// Locale'i otomatik ekleyen Link/router sarmalayıcıları.
/// Bileşenlerde next/link YERİNE bunlar kullanılır — yoksa /tr/dashboard
/// yerine /dashboard'a gidilir ve dil sıfırlanır.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
